import { createUseStyles } from "react-jss";
import { COLORS } from "./defaults";

export const inputStyles = {
    input: {
        width: "98%",
        height: "3em",

        borderStyle: "none",
        borderRadius: "12px",

        paddingLeft: "2%",
        padding: "0.2em 0em",
        backgroundColor: "#E2E5F0",
        color: COLORS.primary.main,

        "&:focus": {
            outline: COLORS.primary.main,
            boxShadow: COLORS.primary.shadowBox,
            border: `0.1em solid ${COLORS.primary.main}`,
        },

        boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
    },
    dropdownSelector: {
        width: "100%",
        height: "2.5em",

        display: "flex",
        flexWrap: "nowrap",
        alignItems: "center",
        justifyContent: "space-between",

        cursor: "pointer",
        borderRadius: "0.5em",

        "&:hover": {
            color: COLORS.primary.main,
            backgroundColor: "ghostwhite",
            boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.16) 0px 3px 6px"
        },

        boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
    },
    dropdownOptionsContainer: {
        maxHeight: "50%",
        overflowY: "scroll",
        padding: "1em 0.5em",
        borderRadius: "0 0 0.5em 0.5em",
        boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.3) 0px 3px 6px",
    },
    dropdownOpen: {
        color: COLORS.primary.main,
        backgroundColor: "ghostwhite",
        boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.3) 0px 3px 6px"
    },

    dropdownOption: {
        cursor: "pointer",
        textAlign: "left",
        borderRadius: "0.8em",
        padding: "0.8em 0.5em",
        "&:hover": {
            color: COLORS.primary.main,
            backgroundColor: "ghostwhite"
        },
    },

    textCenter: {
        padding: "0",
        textAlign: "center"
    },

    marginT1em: { marginTop: "1em" },
    marginTB1em: {
        marginTop: "1em",
        marginBottom: "1em"
    },
    error: {
        border: "0.1em solid #be123c"
    },
    width10: { width: "10%" },
    width15: { width: "15%" },
    width20: { width: "20%" },
    width70: { width: "70%" },
    width80: { width: "80%" },
    inputTransparent: {
        borderRadius: "25px",
        width: "130px",
        backgroundColor: "#efefef",
        border: "2px solid black",
        padding: "0 10px",
        cursor: "pointer",
        "&:hover": {
            color: COLORS.primary.main,
            boxShadow: "0px 0px 1px 1px #5F03F4"
        }
    }
};
export const inputClasses = createUseStyles(inputStyles);